import Skeleton from '@/components/Skeleton';

function WorkspaceCardSkeleton() {
  return (
    <div className="rounded-lg bg-white p-6 shadow dark:bg-gray-800 dark:shadow-gray-900">
      <div className="mb-2 flex items-start justify-between">
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-5 w-12 rounded" />
      </div>
      <Skeleton className="mb-3 h-4 w-full" />
      <div className="flex items-center justify-between">
        <Skeleton className="h-3 w-16" />
        <Skeleton className="h-3 w-12" />
      </div>
    </div>
  );
}

export default function WorkspaceSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: 6 }).map((_, i) => (
        <WorkspaceCardSkeleton key={i} />
      ))}
    </div>
  );
}
